//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const fallback = {
  nombre: null,
  apellido_paterno: null,
  apellido_materno: null,
  numero_seguridad_social: null,
  telefono_celular: null,
  correo_electronico: null,
  entidad_federativa: {
    id: null,
    nombre: null,
    abreviatura: null,
  },
  fecha_nacimiento: null,
  curp: null,
}

export default {
  props: {
    prospecto: {
      required: true,
      type: Object,
      default() {
        return fallback
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
}
